/**
 * Componente que exibe a tela de sucesso após a vinculação bem-sucedida
 * entre o usuário e um profissional.
 */
import React from 'react';
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import StateIcon from '../shared/StateIcon';
import classes from '../../RescueCode.module.scss';
import rocketIcon from "../../../../../assets/images/rocket.svg";

/**
 * SuccessView - Exibe a confirmação de vinculação bem-sucedida
 * 
 * @param {Object} newParentUser - Dados do profissional com quem o usuário foi vinculado
 * @param {Function} redirectToDashboard - Função para redirecionar o usuário ao painel principal
 */
const SuccessView = ({ newParentUser, redirectToDashboard }) => {
  return (
    <StateView className={classes.successContainer}>
      {/* Título principal da mensagem de sucesso */}
      <H1 className={classes.successTitle}>Tudo certo!</H1>

      {/* Mensagem informando sobre a vinculação bem-sucedida */}
      <LinkMessage className={classes.successMessage}>
        <p>Agora você está vinculado à <strong>{newParentUser?.given_name || "um profissional"}</strong>.</p>
      </LinkMessage>

      {/* Ícone de sucesso - mostra o foguete se disponível, senão o ícone de check */}
      <StateIcon 
        icon={faCheck}
        imageSrc={rocketIcon}
        altText="Ícone de Foguete"
        iconContainerClass={classes.rocketIconContainer}
        iconClass={classes.successIcon}
      />

      {/* Botão para retornar ao painel principal */}
      <RoundedButton
        className={classes.returnButton}
        text="VOLTAR AO PAINEL"
        onClick={redirectToDashboard}
      />
    </StateView>
  );
};

export default SuccessView;